import { CInput, CInputGroup, CLabel } from '@coreui/react';
import * as React from 'react';
import { Utils } from '../../core/utils';
import { ControlModel } from '../../models/index';
import { KComplements } from '../KComplements';

interface IProps {
	Control: ControlModel
}

export class KControlLabel extends React.Component<IProps> {

	public constructor(props: any) {
		super(props);
	}

	render() {
		let ctrl = this.props.Control;
		if (!ctrl.Visible) return null;

		let inlineStyle = Utils.decodeInlineStyleFromJson(ctrl.InlineStyle);
		let bsSize = Utils.getColSizeClasses(ctrl);

		return (
			<div className={`KControl KControlLabel ${ctrl.Class} ${bsSize}`} style={inlineStyle} >
				<CLabel htmlFor={this.props.Control.Key} >{ctrl.Description}</CLabel>
				<CInputGroup >
					<CInput className="input" disabled readOnly={true} name={this.props.Control.Key} color="default" value={ctrl.Value} ></CInput>
				</CInputGroup>

				<KComplements Control={ctrl}/>
			</div>
		)
	}
}